import { useNavigate, useParams } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { MyTrainingSessionsPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import {
  SessionSidePanel,
  SessionSidePanelAttendance,
  SessionSidePanelBriefing,
} from 'modules/trainings/components/Revamp/MyTrainings/SessionDetail'

export default function SessionSidepanel({ back }: { back?: string }) {
  const { access } = useCurrentSession()
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const { sessionId, trainingId } = useParams()

  const { data } = useQuery(MyTrainingSessionsPageDocument, {
    variables: {
      accessId: access.id,
      trainingId: Number(trainingId),
      sessionIds: [Number(sessionId)],
    },
  })
  const sessions = data?.trainings.sessionsConnection.nodes ?? []
  const session = sessions[0]

  const onClose = () => {
    if (back) {
      navigate(back)
    } else {
      navigate(
        navigation.myTrainings.revamp.detailsRevamp.view.sessions.fullPath({
          trainingId: Number(trainingId),
        })
      )
    }
  }
  if (!session) return null

  const sessionAttendance = session?.sessionAttendances.find(
    (attendance) => attendance.accessId === access.id
  )

  return (
    <SessionSidePanel session={session} open onClose={onClose}>
      <Box gap="s32">
        <SessionSidePanelAttendance
          canEdit={Boolean(sessionAttendance?._policies?.edit.can)}
          sessionAttendance={sessionAttendance}
        />
        <SessionSidePanelBriefing session={session} />
      </Box>
    </SessionSidePanel>
  )
}
